import { combineEpics } from 'redux-observable';

import { appEpics } from './app';
import { timekeepingEpics } from './timekeeping';

const rootEpics = combineEpics(...appEpics, ...timekeepingEpics);

export default rootEpics;
